import { useState } from "react";
import BodyCard from "../../../../components/fundamentals/body-card/body-card";
import Breadcrumb from "../../../../components/fundamentals/breadcrumb/Breadcrumb";
import TableViewHeader from "../../../../components/fundamentals/custom-table-header";
import FlowTable from "../flows/flow-table/FlowTable";
import SyncLauncher from "./SyncLauncher";

const VIEWS = ["Synchronisation"];

/**
 * RAG-32 — Écran « Synchronisation ».
 * En haut : les boutons de lancement manuel. En dessous : le suivi des traitements
 * (la même liste de « Process » que « Flux automatiques »), rafraîchie à chaque lancement.
 */
export default function SynchronisationPage() {
  // Change à chaque lancement/transition pour forcer la liste à se recharger.
  const [refreshToken, setRefreshToken] = useState(0);

  return (
    <div className="flex flex-col grow h-full">
      <div className="w-full flex flex-col grow">
        <Breadcrumb
          previousRoute="/settings"
          previousBreadcrumb="Paramètres"
          currentPage={"Synchronisation"}
        />
        <BodyCard className="h-fit mb-base">
          <SyncLauncher onChanged={() => setRefreshToken((n) => n + 1)} />
        </BodyCard>
        <BodyCard
          forceDropdown={false}
          customHeader={<TableViewHeader views={VIEWS} />}
          className="h-fit"
        >
          <FlowTable key={refreshToken} />
        </BodyCard>
      </div>
    </div>
  );
}
